export type ContentPreviewParams = {
  countryCode: string;
  regionCode: string;
};

export type CourseTypeExtension = {
  courseId: string;
};

export type GoalIdTypeExtension = {
  goalId: string;
};

export const CONTENT_PREVIEW_ROUTE = {
  name: 'contentpreview/:countryCode/:regionCode',
  route(params: ContentPreviewParams): string[] {
    return ['/contentpreview', params.countryCode, params.regionCode];
  },
  DEFAULT: '',

  PREVIEW_COURSE: {
    name: ':courseId',
    route(params: ContentPreviewParams & CourseTypeExtension): string[] {
      return [...CONTENT_PREVIEW_ROUTE.route(params), params.courseId];
    },
    PREVIEW_GOAL: {
      name: ':courseId',
      route(params: ContentPreviewParams & CourseTypeExtension & GoalIdTypeExtension): string[] {
        return [...CONTENT_PREVIEW_ROUTE.PREVIEW_COURSE.route(params), params.goalId];
      }
    }
  }
};
